import { Link } from '@epo/epods-react-components';
import React from 'react';
import { useTranslation } from 'react-i18next';

const DownloadLimitPage = () => {
    const [t] = useTranslation();
    return (
        <div>
            <br />
            <div className="mb-s">{t('LIMIT_PAGE::SALUTATION')}</div>
            <div className="mb-s">{t('LIMIT_PAGE::1ST_NOTICE_PARAGRAPH')}</div>
            <div className="mb-s">{t('LIMIT_PAGE::2ND_NOTICE_PARAGRAPH')}</div>
            <div className="mb-s">
                {t('LIMIT_PAGE::3ND_NOTICE_PARAGRAPH')}{' '}
                <Link
                    href="mailto:support@epo.org?subject=European%20publication%20server"
                >
                    {t('LIMIT_PAGE::SUPPORT')}
                </Link>
            </div>
            <div className="mb-s">{t('LIMIT_PAGE::THANKS')}</div>

            <div>
                <div>{t('LIMIT_PAGE::EPO')}</div>
                <div>
                    {t('LIMIT_PAGE::DIRECT')}{' '}
                    <Link
                        href="https://www.epo.org"
                    >
                        www.epo.org{' '}
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default DownloadLimitPage;
